import { Alert, Box } from '@mui/material'

const TOCForm = () => {
  return (
    <Box p={1}>
      <Alert severity="info">Das Inhaltsverzeichnis wird am Ende automatisch generiert.</Alert>
    </Box>
  )
}

export default TOCForm
